<script setup lang="ts">
import { differenceInCalendarMonths, startOfMonth } from 'date-fns';
import { addMonths, getMonthName, getMonthsPeriod, getMaxDate } from '@sub/utils/times';

const props = withDefaults(defineProps<{
  minDate?: Date;
  maxDate?: Date;
}>(), {
  minDate: () => new Date(),
});

const focus = defineModel<Date>('focus', { default: () => new Date() });

const months = getMonthsPeriod(props.minDate, minDate([addMonths(props.minDate, 24), props.maxDate].filter(Boolean)))
  .map(d => getMonthName(d) + (props.minDate.getFullYear() !== d.getFullYear()? ` ${d.getFullYear()}` : '' ));


function getSlideIndex(d: Date) {
  if (!d) return 0;
  return differenceInCalendarMonths(d, props.minDate);
}

const focusIndex = computed(() => getSlideIndex(focus.value));

function updateDate(index: number) {
  focus.value = getMaxDate([props.minDate, startOfMonth(addMonths(props.minDate, index))]);
}
</script>

<template lang="pug">
UiSliderMonthSlider(
  :items="months"
  :initial="0"
  :index="focusIndex"
  @update:index="updateDate"
)
  template(v-slot="{item, isActive}")
    .month.flex-center-center.w-100p.typ-14-18-500(:class="{active: isActive}") {{ item }}
</template>

<style scoped lang="scss">
.month {
  color: #C3C9CF;
  cursor: pointer;

  &.active {
    color: #1f1f1f;
  }
}
</style>